import { ReactNode } from 'react';
import { TicketDetailsProps } from '@spendbrain/modules/tickets/components';
import { create } from 'zustand';

export enum DialogScreen {
  CreateTicket = 'create-ticket',
  TicketDetails = 'ticket-details',
  VendorContracts = 'vendor-contracts',
}

export type DialogScreenOpenedElement =
  | {
      component: DialogScreen.CreateTicket;
      dialogTitle: string;
      onClose?: () => void;
    }
  | {
      component: DialogScreen.TicketDetails;
      componentProps: TicketDetailsProps;
      dialogTitle: ReactNode;
      onClose?: () => void;
    }
  | {
      component: DialogScreen.VendorContracts;
      dialogTitle: ReactNode;
      onClose?: () => void;
    };

interface DialogStoreActions {
  open: (opened: DialogScreenOpenedElement) => void;
  close: () => void;
  setClosable: (closable: boolean) => void;
}

interface DialogStoreValues {
  opened: DialogScreenOpenedElement | null;
  closable: boolean;
}

interface DialogStore extends DialogStoreValues, DialogStoreActions {}

export const useDialogStore = create<DialogStore>(set => ({
  opened: null,
  closable: true,
  open: opened => set({ opened }),
  close: () => set({ opened: null }),
  setClosable: closable => set({ closable: closable }),
  componentProps: {},
}));
